module.exports = __webpack_public_path__ + "img/9788930315395.97b93ce1.jpg";